import { connectStateResults, Highlight, Hits, InstantSearch, Pagination, PoweredBy, SearchBox } from 'react-instantsearch-dom';
import React, { useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import StateResults from './StateResults';

const algoliaClientForJa = algoliasearch('2WXWHKRGVE', '23dbae1ea12c2fa579e35989497840b8');


// fix initial query with empty parameters
// https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/react/
// https://codesandbox.io/s/github/algolia/doc-code-samples/tree/master/React%20InstantSearch/conditional-request?file=/src/App.js:255-292
const searchClientForJa = {
  search (requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          processingTimeMS: 0,
        })),
      });
    }

    return algoliaClientForJa.search(requests);
  },
};

function HitForJa (props) {

  const [ isAdditionalWordsExpanded, setAdditionalWordsExpanded ] = useState(false);

  return (
    <article>
      <p className="hit__text hit__text--ja">
        <Highlight attribute="text_kanji" hit={props.hit} />
      </p>
      <p className="hit__text hit__text--ja">
        <Highlight attribute="text_romaji" hit={props.hit} />
      </p>
      <p className="hit__text hit__text--fr">
        <Highlight attribute="text_fr" hit={props.hit} />
      </p>
      {(props.hit.additional_keywords_ja || props.hit.additional_keywords_fr) && <aside>
        <button onClick={() => {setAdditionalWordsExpanded(!isAdditionalWordsExpanded);}}
                className={`hit__additional-keywords__btn ${isAdditionalWordsExpanded ? 'hit__additional-keywords__btn--expanded' : ''}`}>{'>'}</button>
        <div className={`hit__additional-keywords ${isAdditionalWordsExpanded ? 'hit__additional-keywords--expanded' : 'hit__additional-keywords--reduced'}`}>
          <p className="hit__additional-keywords--ja">
            <Highlight attribute="additional_keywords_ja" hit={props.hit} />
          </p>
          <p className="hit__additional-keywords--fr">
            <Highlight attribute="additional_keywords_fr" hit={props.hit} />
          </p>
        </div>
      </aside>
      }
    </article>
  );
}

const CustomStateResults = connectStateResults(StateResults);

function DicoForJa () {
  const [ wordToLookFor, setWordToLookFor ] = useState('');

  return (<>
    <form noValidate onSubmit={e => { e.preventDefault(); }}>
      <div>
        <label htmlFor="theWordToLookFor">Word to open in a dictionary</label>
        <button className="copy-search-word" onClick={() => setWordToLookFor(document.querySelector('.app-ja input[type="search"]').value)}>copy from search input</button>
      </div>
      <input type="text"
             id="theWordToLookFor"
             name="theWordToLookFor"
             value={wordToLookFor}
             className="dico__component dico__input"
             onChange={(e) => setWordToLookFor(e.target.value)} required />
      <div className="dico_hrefs">
        <a href={'https://jisho.org/search/' + wordToLookFor} target="_blank" rel="noopener noreferrer"
           className="dico__href">Jisho</a>
      </div>
    </form>
  </>);

}

export default function AppJa () {
  return (
    <main className="app-ja">
      <h2 className={'visually-hidden'}>App Ja</h2>
      <section className="ais-InstantSearch">
        <InstantSearch indexName="dev_ja" searchClient={searchClientForJa}>
          <SearchBox showLoadingIndicator autoFocus searchAsYouType={false} />
          <CustomStateResults />
          <Hits hitComponent={HitForJa} />
          <Pagination />
          <PoweredBy />
        </InstantSearch>
      </section>
      <section className="dico__section">
        <DicoForJa />
      </section>
    </main>
  );
}

